module.exports = __webpack_public_path__ + "img/menu_icon08.748dc6d6.png";